import { render, staticRenderFns } from "./DisplayCategoryIframe.vue?vue&type=template&id=e1742d50&"
import script from "./DisplayCategoryIframe.vue?vue&type=script&lang=ts&"
export * from "./DisplayCategoryIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports